<div class="nav-wrapper">
  <h4 class="mb-0">{{ activeCrumb }}</h4>
  <div class="dropdown">
    <div
      class="user-profile"
      id="dropdownMenuButton2"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      (shown.bs.dropdown)="dropdownOpen = true"
      (hidden.bs.dropdown)="dropdownOpen = false"
    >
      <div class="d-flex align-items-center pe-3">
        <img
          width="65"
          *ngIf="!userObj.profileFileUrl"
          src="assets/images/company-management/ic_userSample.svg"
          id="profileImgUrl"
        />
        <div class="profile-pic" *ngIf="userObj.profileFileUrl">
          <img [src]="userObj.profileFileUrl" id="profileImgUrl" />
        </div>
        <div class="user-name">
          <h3 class="name" id="id_udisplayName">
             {{ userObj.displayName && userObj.displayName.trim() ? userObj.displayName : userObj.firstName + ' ' + userObj.lastName }}
          </h3>
          <div class="d-flex">
            <h6 class="secondary mb-0" id="id_userRole">
              {{ isRoleArray ? userDetails.role[0] : userDetails.role }}
            </h6>
            <div *ngIf="isRoleArray" class="c-pt view-more ms-1">
              <h6 class="secondary mb-0" id="id_userRole">+{{ userDetails.role.length - 1 }}</h6>
              <ul class="show-list">
                <li class="text-white" *ngFor="let rl of userDetails.role.slice(1); trackBy: trackById">
                  {{ rl }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- ↓↓↓ Arrow icon with rotation -->
        <img
          src="../../../../assets/images/icon-park_down.svg"
          alt="dropdown"
          id="dropdownImg"
          [ngStyle]="{
            transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          }"
        />
      </div>

      <ul class="dropdown-menu mt-1" aria-labelledby="dropdownMenuButton2" id="id_dropdownmenu">
        <li>
          <a
            class="dropdown-item text-black"
            style="font-weight: 500; text-wrap: wrap"
            (click)="nevigate('company')"
            >{{ userObj.company?.name }}</a
          >
          <a class="dropdown-item" (click)="nevigate('my profile')">My Profile</a>
          <a class="dropdown-item" (click)="nevigate('user passcodes')">Manage User Passcodes</a>
          <a class="dropdown-item" (click)="logout()">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</div>
